// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1aU3h","header":"ClearentDisclaimer_header__3VBIH","inner":"ClearentDisclaimer_inner__KYgz7"};